import { removeArrayElement } from "../../../utils/general";
import { ADD_UNIT, DELETE_UNIT, LOAD_PROPERTIES_UNITS_TENANTS, LOG_OUT_USER, UPDATE_UNIT } from "../../actions/actionTypes";

const fetchUnitsReducer = (units, payload) => {
    let newUnits = [...units];
    for(let unit of Object.values(payload.units)){
        newUnits.push(unit.unitId);
    }
    let uniqueIds = [...new Set(newUnits)];
    return uniqueIds;
}

const addUnitsReducer = (units, payload) => {
    let newUnits = [ ...units ];
    newUnits.unshift(payload.unitId)

    return newUnits;
}

const deleteUnitsReducer = (units, payload) => {
    let newUnits = [ ...units ];
    let remainingUnits = removeArrayElement(newUnits, payload.unitId)
    
    return remainingUnits;
}


const unitsOrderReducer = (state=[], action) => {
    let unitsOrder = state;
    if (action && action.payload && !action.payload.errors){
        switch(action.type){
            case LOAD_PROPERTIES_UNITS_TENANTS:
                return fetchUnitsReducer(unitsOrder, action.payload);
            case ADD_UNIT:
                return addUnitsReducer(unitsOrder, action.payload);
            case DELETE_UNIT:
                return deleteUnitsReducer(unitsOrder, action.payload);
            case LOG_OUT_USER:
                return [];
            default:
                return unitsOrder;
        }
    }
    return unitsOrder;
}

export default unitsOrderReducer;